module.exports = __webpack_public_path__ + "img/purchase1.c1bf1355.png";